import { Container } from "@mui/material";
import { Productos } from "../../componentes/Productos/Productos";
import { CasUserContext } from "../../services/casUserContext";
import { useContext, useEffect, useState} from 'react';
import { array } from "yup";
import { useNavigate } from "react-router-dom";
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import UsuarioService from "../../services/UsuarioService";

const usuarioService = new UsuarioService();

export const ProductoPage: React.FC<{}> = () =>{
    const casUserContext = useContext(CasUserContext);
    const userData = casUserContext.userData;
    const [auth,setAuth] = useState(false);

    //Seccion Carga
    useEffect(() => {
        const flag = usuarioService.authorized(userData.roles);
        setAuth(flag);
    },[userData]);

    return(
        <Container maxWidth="lg" sx={{mt:4}}>
            {auth ? 
                <Productos/>
                :
                <UnauthorizedPage />
            }
        </Container>
    );
}